import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

export function useSaveTreatment(patientId) {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback(
    (treatment) => {
      setSaving(true);
      return quarkusApi
        .post(`/patients/${patientId}/treatments`, treatment, {
          headers: { Authorization: sessionStorage.getItem('token') },
        })
        .finally(() => setSaving(false));
    },
    [patientId],
  );

  return { save, isSaving };
}
